import { useSearchParams } from 'react-router-dom';

import { useFeatureFlags } from './useFeatureFlags';

/**
 * Returns whether Web Forms skip logic is enabled.
 * Skip logic is active when either the WebFormsSkipLogic feature flag is on
 * or the form is accessed via a share token (shared forms).
 *
 * Note: WebFormsSkipLogic is fully released but must exist because a specific
 * client needs it off; it is hardcoded in backend to remove the flag for that client.
 */
export function useWebformsSkipLogic(): boolean {
  const { checkFlag } = useFeatureFlags();
  const [searchParams] = useSearchParams();
  const shareToken = searchParams.get('share_token');

  return checkFlag('WebFormsSkipLogic') || !!shareToken;
}
